const mePegasusMain = {
  title: 'WE ARE PEGASUS ARMS',
  paragraphs: [
    'A Ukrainian defense technology company. We develop reusable strike UAVs capable of operating autonomously even in a high-intensity EW environment.',
    'Our systems operate in automatic control mode, with inertial navigation and secure FHSS communications.',
    'We have proven our effectiveness in action — assisting Ukraine’s Defense Forces in achieving Victory on a daily basis.',
  ],
}
export default mePegasusMain
